module.exports = __webpack_public_path__ + "static/9ab1d92b6e87c118d91f32a6a66d3c5ed36b5ed9da1eec516b0e741813cd0a4a-17866a44e12e4fa0c521b123e55ceed9.jpeg";